import { FC } from 'react';
import SpriteIcon from '../shared/sprite-icon';
import { useTranslation } from '../../hooks/use-translation';
import { dispatch } from '../../hooks/use-bus';
import { AppBusEventType } from '../../interfaces/bus-events';

interface UninstallAppButtonProps {
  extensionId: string;
  appName: string;
}

// -----------------------------------------------------------------------------
export const UninstallAppButton: FC<UninstallAppButtonProps> = ({
  extensionId,
  appName,
}): JSX.Element => {
  const { t } = useTranslation();

  const handleClick = (): void => {
    dispatch({
      type: AppBusEventType.App.ShowUninstallModal,
      data: {
        appName,
        extensionId,
      },
    });
  };

  return (
    <li className='option-item'>
      <button className='option-item-btn' onClick={handleClick}>
        <svg>
          <SpriteIcon icon='uninstall' />
        </svg>
        {t('uninstallApp')}
      </button>
    </li>
  );
};
